// extracted by mini-css-extract-plugin
module.exports = {"Container":"_17GI-","MobilePageContainer":"H8VJE","Aside":"uEZIo","InfoBar":"_1BxTs"};